export default __webpack_public_path__ + "static/3-45c11ffb843e5f7a1d71c606fd7dc2b2.jpeg";